/* eslint-disable complexity */
/* eslint-disable max-depth */
// Copyright (c) 2020 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {getDetails, getPartDetails, getProductWarranties} from '../../../product/shared/repositories';
import actions from '../../actions-list';
import {createPartsCoverageSearch} from '../../shared/repositories';
import {readCustomerDetails} from '../../../customer/details/action-creators/details';
import {readLatestPerUnitMeasurements} from '../../../shared/action-creators/latest-per-unit-measurements';

export const fetchPartCoverageSearch = postArgs =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            dispatch({
                type: actions.RESET_PART_COVERAGE_SEARCH_ADDITIONAL_INFORMATION
            });

            const data = await createPartsCoverageSearch(postArgs);

            const hasNoResult = !data.length;

            dispatch({
                data,
                type: actions.CREATE_PART_COVERAGE_SEARCH_REPORT_SUCCESS
            });

            if (!hasNoResult) {

                const part = await getPartDetails(postArgs.partNumber);

                dispatch({
                    part,
                    type: actions.UPDATE_PART_COVERAGE_SEARCH_PART_DETAILS_SUCCESS
                });

                if (postArgs.pin !== '') {

                    const warranties = await getProductWarranties(postArgs.pin, postArgs.currentMachineHours);
                    const details = await getDetails(postArgs.pin);

                    dispatch({
                        type: actions.UPDATE_PART_COVERAGE_SEARCH_WARRANTIES_SUCCESS,
                        warranties
                    });

                    dispatch({
                        pin: postArgs.pin,
                        type: actions.UPDATE_PART_COVERAGE_SEARCH_PIN
                    });

                    dispatch({
                        details,
                        type: actions.UPDATE_PART_COVERAGE_SEARCH_PRODUCT_SUCCESS
                    });

                    if (details.customerSummary.id && !details.customerPrivate) {

                        readCustomerDetails(details.customerSummary.id)(dispatch);

                    }

                    if (details.otherUnitRequired === 'N') {

                        readLatestPerUnitMeasurements(postArgs.pin)(dispatch);

                    }

                }

            }

            dispatch({
                hasNoResult,
                type: actions.UPDATE_SHOW_NO_RESULTS_FOUND
            });

        } catch (error) {

            dispatch({
                hasNoResult: false,
                type: actions.UPDATE_SHOW_NO_RESULTS_FOUND
            });

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const resetPartCoverageSearch = () => ({
    type: actions.RESET_PART_COVERAGE_SEARCH_REPORT
});



// WEBPACK FOOTER //
// ./src/reports/parts-coverage-search/action-creators/report.js